import {
    LOANREQUEST_STATUSES,
    SUB_STATUS_APPROVED,
    SUB_STATUS_IN_PROGRESS,
    SUB_STATUS_INITIAL,
    SUB_STATUS_OFFER_AT_BANK,
    SUB_STATUS_OFFER_AT_CUSTOMER,
} from 'cpool-constants';

export const loanRequestStatusesWithSubStatuses = {
    [LOANREQUEST_STATUSES.INITIAL]: SUB_STATUS_INITIAL,
    [LOANREQUEST_STATUSES.IN_PROGRESS]: SUB_STATUS_IN_PROGRESS,
    [LOANREQUEST_STATUSES.OFFER_AT_CUSTOMER]: SUB_STATUS_OFFER_AT_CUSTOMER,
    [LOANREQUEST_STATUSES.OFFER_AT_BANK]: SUB_STATUS_OFFER_AT_BANK,
    [LOANREQUEST_STATUSES.APPROVED]: SUB_STATUS_APPROVED,
};
